import axios, { AxiosInstance } from 'axios';
import { SimpliPayConfig, TransactionRequest, OtpAuthRequest, ApiResponse } from '../types';

const API_URLS = {
  development: 'https://devpay.voxepay.app',
  production: 'https://pay.voxepay.app',
};

const ENDPOINTS = {
  initiate: '/api/v1/payments/initiate',
  otpVerify: '/api/v1/payments/otp/verify',
  otpResend: '/api/v1/payments/otp/resend',
};

export const createApiClient = (config: SimpliPayConfig): AxiosInstance => {
  const baseURL = config.baseUrl || API_URLS[config.environment || 'development'];
  
  const client = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': config.publicKey,
    },
  });

  return client;
};

export const initiatePayment = async (
  client: AxiosInstance,
  payload: TransactionRequest
): Promise<ApiResponse> => {
  const { data } = await client.post(ENDPOINTS.initiate, payload);
  return data;
};

export const verifyOtp = async (
  client: AxiosInstance,
  payload: OtpAuthRequest
): Promise<ApiResponse> => {
  const { data } = await client.post(ENDPOINTS.otpVerify, payload);
  return data;
};

export const resendOtp = async (
  client: AxiosInstance,
  transactionRef: string
): Promise<ApiResponse> => {
  const { data } = await client.post(ENDPOINTS.otpResend, { transactionRef });
  return data;
};
